import { commonFocusableElements } from "@app/shared/utility/commonFocusableElements";
import { RefObject } from "react";

export const focusFirstInteractiveElement = (ref?: RefObject<HTMLElement>): void => {
  const firstFocusableElement = ref?.current?.querySelector(commonFocusableElements) as HTMLElement;
  if (!!firstFocusableElement) {
    firstFocusableElement.focus();
  } else {
    // if there's nothing to focus on in the given element (or no ref),
    // this should get the first thing in the app body
    (document.querySelector(".app-main").querySelector(commonFocusableElements) as HTMLElement)?.focus();
  }
}
